export const TOTAL_STEPS = 4
